import React from 'react';
import NavigationHeader from '../components/NavigationHeader';
import { Hero, ProblemSolution, Features, Screenshots, GetApp } from '../components/HomeSection';
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import '../styles/screens/Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-container">
      <NavigationHeader />
      <Hero />
      <ProblemSolution />
      <Features />
      <Screenshots />
      <GetApp />
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Home;
